import Card from '@/components/Card/Card';
import styles from './SuccessPage.module.css';
import Button from '@/components/Button/Button';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { useNavigate, useParams } from 'react-router-dom';
import { SuccessProps } from '../CreateNavCode.types';

export const SuccessPage = (props: SuccessProps) => {
  const { setShowSuccessPage } = props;
  const { bundleId } = useParams();
  const navigate = useNavigate();

  return (
    <div className={styles.accordionContainer}>
      <Card>
        <div className={styles.widgetBody}>
          <h1>Navigation Code created successfully</h1>
          <CheckCircleOutlineOutlinedIcon
            sx={{
              fontSize: '70px',
              color: 'green',
            }}
          />
          <div>
            <Button
              data-testid="redirect"
              onClick={() => {
                setShowSuccessPage(false);
                navigate(`/bundles/${bundleId}/viewNavCode`);
              }}
            >
              Back to Navigation Codes
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};
